import React, {Component} from 'react';
import ValueTypeSelector from "./ValueTypeSelector";
import {connect} from "react-redux";
import axios from 'axios';
import {showToastForBackend, showToastForFrontend} from "../../../actions/toastActions";
import axiosConfig from "../../../utils/axiosConfig";
import messageCodes from "../../../utils/messageCodes";
import MaterialIcon from "../../MaterialIcon";
import SelectBox from "./SelectBox";
import InputWithLabel from "./InputWithLabel";

class DynamicPropertyInput extends Component {

    constructor(props) {
        super(props);

        this.types = [
            {
                text: "Context Property",
                xmlType: "contextProperty"
            },
            {
                text: "Item Property",
                xmlType: "itemProperty"
            },
            {
                text: "Constant Value",
                xmlType: "constantValue"
            }/*,

            {
                icon: "list",
                text: "Mesp Expression",
                xmlType: "mespExpression"
            }
            */
        ];

        this.state = {
            type: this.props.type || this.types[0].xmlType,
            name: this.props.name || "",
            value: this.props.value || "",
            extensionValue: this.props.extensionValue || null,
            itemProperties: [],
            showRegex: !!(this.props.type === "itemProperty" && this.props.extensionValue) || false,
            showSignificantDigit: (this.props.type === "mespExpression" && this.props.extensionValue) || false
        };
        this.onDynamicPropertyTypeChange = this.onDynamicPropertyTypeChange.bind(this);
        this.getItemProperties = this.getItemProperties.bind(this);
        this.onValueChange = this.onValueChange.bind(this);
        this.toggleRegex = this.toggleRegex.bind(this);
        this.toggleSignificantDigit = this.toggleSignificantDigit.bind(this);
    }

    componentDidMount() {
        this.getItemProperties();
    }

    componentDidUpdate(prevProps, prevState) {
        const shouldUpdateParent = (prevState.name !== this.state.name) || (prevState.value !== this.state.value) || (prevState.type !== this.state.type) || (prevState.extensionValue !== this.state.extensionValue);

        if (shouldUpdateParent) {
            const dynProp = {
                type: this.state.type,
                name: this.state.name,
                value: this.state.value,
                extensionValue: this.state.extensionValue
            };
            this.props.updateDynamicProperty(dynProp);
        }

    }

    getItemProperties() {
        axios.get(this.props.properties.databaseUrl + "/properties/items", axiosConfig())
            .then(response => {
                this.setState({
                    itemProperties: response.data.sort()
                });
            })
            .catch(err => {
                if (err.response)
                    this.props.showToastForBackend(err.response.data);
                else
                    this.props.showToastForFrontend(messageCodes.CONNECTION_ERROR);
            })
    }

    onDynamicPropertyTypeChange(selectedTypeText) {
        const selectedType = this.types.find(type => type.text === selectedTypeText).xmlType;
        this.setState({type: selectedType});
    }

    onValueChange(e, type) {
        const value = e.target.value;
        this.setState({[type]: value});
    }

    toggleRegex() {
        let update = {showRegex: !this.state.showRegex};
        if (this.state.showRegex) {
            update = {
                ...update,
                extensionValue: null
            }
        }
        this.setState({
            ...update
        });
    }

    toggleSignificantDigit() {
        let update = {showSignificantDigit: !this.state.showSignificantDigit};
        if (this.state.showSignificantDigit) {
            update = {
                ...update,
                extensionValue: null
            }
        }
        this.setState({
            ...update
        });
    }

    renderTypeInput() {
        switch (this.state.type) {
            case "contextProperty":
                return (
                    <SelectBox
                        selectArray={this.props.contextProperties.sort(
                            (a, b) => a.name > b.name ? 1 : -1
                        ).map(prop => ({label: prop.name, value: prop.name}))}
                        selectValue={this.state.value}
                        handleChangeSelect={(e) => this.onValueChange(e, "value")}/>
                );
            case "itemProperty":
                return (
                    <div className="item-prop-selector">
                        <SelectBox selectArray={this.state.itemProperties.map(prop => ({label: prop, value: prop}))}
                                   selectValue={this.state.value}
                                   handleChangeSelect={(e) => this.onValueChange(e, "value")}/>
                        {/*
                         <label className="checkbox-wrapper">
                            <input type="checkbox" className="checkbox" checked={this.state.showRegex}
                                   onChange={() => this.toggleRegex()}/>
                            Regex
                        </label>
                        {this.state.showRegex && (
                            <input className="dyn-prop-input" type="text" placeholder="Enter a value"
                                   value={this.state.extensionValue}
                                   onChange={(e) => this.onValueChange(e, "extensionValue")}/>
                        )}
                        */}
                    </div>
                );

            case "constantValue":
                return (
                    <input className="dyn-prop-input" type="text" placeholder="Enter a value" value={this.state.value}
                           onChange={(e) => this.onValueChange(e, "value")}/>
                );
            /*case "mespExpression":
                return (
                    <div>
                        <input className="dyn-prop-input" type="text" placeholder="Enter Expression"
                               value={this.state.value} onChange={this.onValueChange}/>
                        <label className="checkbox-wrapper">
                            <input type="checkbox" className="checkbox" checked={this.state.showSignificantDigit}
                                   onChange={() => this.toggleSignificantDigit()}/>
                            Significant Digits
                        </label>
                        {this.state.showSignificantDigit && (
                            <input className="dyn-prop-input" type="number" placeholder="1"
                                   value={this.state.extensionValue}
                                   onChange={(e) => this.onValueChange(e, "extensionValue")}/>
                        )}
                    </div>
                );
                */
            default:
                return undefined;
        }
    }

    render() {
        return (
            <div className="prop-row">
                <div className="dyn-prop">
                    <div className="dyn-prop-row">
                        <InputWithLabel label="Dynamic Property Name" value={this.state.name}
                                        handleChange={e => this.onValueChange(e, "name")}/>
                    </div>
                    <div className="dyn-prop-row">
                        <div className="type-input">
                            <ValueTypeSelector types={this.types.sort(
                                (a, b) => a.text > b.text ? 1 : -1
                            )}
                                               selectedType={this.state.type}
                                               onTypeSelect={(selectedType) => this.onDynamicPropertyTypeChange(selectedType)}/>
                            {this.renderTypeInput()}
                        </div>
                    </div>
                </div>
                <div className="close-button"
                     onClick={() => this.props.onDelete()}>
                    <MaterialIcon icon="remove_circle"/>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        contextProperties: state.contextProperties,
        properties: state.properties
    }
}

export default connect(mapStateToProps, {showToastForBackend, showToastForFrontend})(DynamicPropertyInput);
